import React, { Suspense } from 'react';
import Image from "../Image";
import { ErrorBoundary } from "react-error-boundary";

const Picture = ({ src, title, extraClasses, fallbackSrc = "/assets/images/Fallbacklogo-grey.png", loadingSrc = "/assets/images/Fallbacklogo-grey.png", ...otherProps }) => {
  return (
    <picture>
      <Suspense fallback={<img src={loadingSrc} className={`${otherProps.className} img-responsive mls-o-loading mls-o-loading--glow`} alt={`${title}-loading`} />}>
        <ErrorBoundary
          fallback={<img src={fallbackSrc} className={`${otherProps.className} img-responsive`} alt={`${title ? title : "fallback"}`} />}
        >
          {src ? <Image src={src} title={title} extraClasses={extraClasses} {...otherProps} /> : null}
        </ErrorBoundary>
      </Suspense>
    </picture>
  );
};

export default Picture;
